<template>
  <div>
    <multiple-charts category="bus" :charts="results" />
  </div>
</template>

<script>
import MultipleCharts from '@/Indicators/Components/MultipleCharts'

export default {
  components: {
    MultipleCharts,
  },
  props: {
    index:      Number,
    indicators: Array,

    results:    Array,
  },
}
</script>
